var _path, _path2, _g, _path3, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2063_44293)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2635 7.53885L10.7099 22.5077C9.94798 23.841 10.9107 25.5 12.4464 25.5H29.5536C31.0893 25.5 32.052 23.841 31.2901 22.5077L22.7365 7.53885C21.9687 6.19522 20.0313 6.19522 19.2635 7.53885Z",
    fill: "#FFA537"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2063_44293",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 6,
    width: 22,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2635 7.53885L10.7099 22.5077C9.94798 23.841 10.9107 25.5 12.4464 25.5H29.5536C31.0893 25.5 32.052 23.841 31.2901 22.5077L22.7365 7.53885C21.9687 6.19522 20.0313 6.19522 19.2635 7.53885Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2063_44293)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.3496 25.6494C20.9996 17.9995 14.5496 14.2496 8.99804 13.8033C3.44649 13.3571 11.0836 32.4796 11.0836 32.4796C19.2272 33.2059 36.0277 33.6407 28.3496 25.6494Z",
    fill: "#D85F06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-50.2305 44.7958C-33.257 21.9381 -15.7813 25.647 -6.77479 20.1825C3.44219 13.9841 10.0116 13.4592 15.2378 15.5203C16.0391 15.8364 16.8091 16.2138 17.5556 16.64M93.1818 54.2999C69.8514 21.8188 57.8516 35.5603 45.2141 33.9867C41.7647 33.5573 38.8369 32.5684 36.2579 31.252M36.2579 31.252C34.623 31.1865 30.5137 31.5833 27.156 33.6914M36.2579 31.252C35.4695 30.8492 34.7133 30.4161 33.9853 29.9585M33.9853 29.9585C28.7664 29.3968 23.9835 32.2763 15.8336 33.9862M33.9853 29.9585C33.2056 29.4687 32.4578 28.9517 31.7353 28.4149M31.7353 28.4149C27.5039 27.9744 20.9681 31.252 13.9789 32.8131M31.7353 28.4149C31.204 28.0205 30.6865 27.615 30.1806 27.2021M8.04588 33.6914C22.1519 30.4235 25.6838 26.6404 30.1801 27.2021C29.5848 26.7169 29.0056 26.2211 28.4384 25.7207M7.4358 33.3835C18.3352 30.1041 21.1778 25.7207 28.4388 25.7207C28.2232 25.5304 28.0094 25.3401 27.7974 25.1484M27.7974 25.1484C17.5233 24.4314 17.0828 29.4374 4.96001 33.3831M27.7974 25.1484C27.4173 24.806 27.0422 24.4623 26.6703 24.119M26.6703 24.119C15.8336 22.4924 12.7827 30.5368 0.787141 33.9862M26.6703 24.119C26.2307 23.7131 25.7967 23.3076 25.3649 22.9053M25.3649 22.9053C7.43534 22.9053 13.0952 27.2021 0.787141 31.252C-6.62827 33.6913 -11.3679 28.1587 -23.5308 33.3835M25.3649 22.9053C24.8226 22.3994 24.2853 21.8989 23.7485 21.4087M-26.7659 33.9862C-19.1607 26.5579 -6.36331 33.3835 2.22755 27.8421C14.0167 20.2378 19.5208 21.2327 23.749 21.4087C23.3647 21.058 22.9808 20.7124 22.5956 20.3738M22.5956 20.3738C22.5956 20.3738 10.6682 17.5832 -2.27984 26.9063C-9.5842 32.1662 -21.1153 26.5418 -28.7183 33.6914M22.5956 20.3738C22.0657 19.9084 21.534 19.4568 20.9958 19.0246M20.9958 19.0246C20.9958 19.0246 10.3567 15.2245 -3.39494 25.1484C-10.4592 30.2465 -24.4298 26.5418 -31.6917 33.6914M20.9958 19.0246C20.5216 18.6435 20.0424 18.2776 19.5563 17.9298M19.5563 17.9298C19.5563 17.9298 10.6415 14.843 0.787141 21.2635C-14.251 31.0612 -23.1893 24.6876 -35.7056 34.3747M19.5563 17.9298C18.9047 17.4639 18.2398 17.0308 17.5556 16.64M17.5556 16.64C17.5556 16.64 8.04588 13.1132 -2.9618 21.7427C-10.5546 27.6947 -25.5527 24.7263 -35.9379 33.6914M15.2378 15.5208C2.22709 13.386 -3.39494 22.2021 -24.4298 26.5423C-31.2733 28.9545 -35.1522 30.4884 -37.5925 33.9867",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-50.2305 42.5317C-27.2382 15.926 -19.0962 24.7832 -6.77479 17.9189C23.6904 0.946336 21.6722 29.6919 45.0552 32.6041C57.6927 34.1781 70.7734 22.4124 93.1818 52.0358",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-49.5352 40.6769C-26.5429 14.0712 -18.2792 23.1427 -6.07949 16.0641C23.8637 -1.30978 22.8223 28.1767 46.2053 31.0889C58.8428 32.6625 71.9337 21.4862 95.2636 53.9673",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-49.5352 39.0643C-23.8898 12.8161 -18.1245 21.3535 -5.92472 14.275C24.0184 -3.0989 23.2061 26.4876 46.5891 29.3993C59.2265 30.9729 71.9336 19.873 95.2636 52.3542",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-49.5352 37.5293C-22.6613 11.5115 -18.6211 19.7752 -6.23154 12.5865C23.7116 -4.78737 23.8204 24.7222 47.2033 27.6344C59.8408 29.2084 71.9341 18.3385 95.2641 50.8201",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-49.6084 35.1569C-26.8834 12.9692 -18.5432 18.2387 -6.15457 11.05C23.055 -5.89811 24.0512 23.0322 47.4342 25.9444C60.0717 27.518 71.9341 17.0324 95.2641 49.5135",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-50.4004 33.1472C-28.1892 12.5842 -18.5441 16.3613 -6.15494 9.17306C23.0546 -7.77506 24.0509 21.1553 47.4338 24.067C60.0713 25.641 75.0975 16.2986 98.4279 48.7798",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-50.4004 30.3995C-29.7586 11.1706 -20.3208 17.0151 -6.44892 8.10956C21.97 -10.1343 24.0509 19.349 47.4338 22.2607C60.0713 23.8348 75.0975 14.4923 98.4279 46.9735",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-50.4004 28.2812C-29.7586 9.05222 -20.3208 14.8968 -6.44892 5.99123C21.97 -12.2526 24.3232 18.1481 47.7061 21.0603C60.3436 22.6343 74.3128 13.3688 98.4279 44.8552",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-48.75 25.7351C-28.1082 6.50613 -22.1613 14.5233 -6.44859 4.43629C20.8819 -13.109 24.012 17.9626 47.395 20.8748C57.523 22.1364 60.3338 12.806 70.1527 20.8748C79.9716 28.9436 105.918 29.5269 105.918 29.5269",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-48.75 24.0144C-28.1082 4.7859 -21.8923 12.6764 -6.17904 2.58934C21.1515 -14.956 24.3507 16.6617 47.7337 19.5734C57.8617 20.835 60.4854 10.8125 71.1461 19.5734C81.8069 28.3343 105.918 27.8058 105.918 27.8058",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-48.75 22.5388C-28.1082 3.30983 -21.8923 11.2008 -6.17905 1.11327C21.1515 -16.432 24.4917 15.1815 47.8746 18.0932C58.0027 19.3548 60.1463 11.5754 68.9463 16.6131C77.7464 21.6509 93.2255 25.1985 105.24 23.7309",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-47.4521 19.0319C-26.8104 -0.196657 -23.1969 10.5184 -7.48369 0.431393C19.8468 -17.1139 25.32 13.814 48.703 16.7261C58.8311 17.9877 60.147 11.1151 68.9471 16.1529C77.7472 21.1907 93.7198 23.8047 105.735 22.3371",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-46.7834 17.2648C-26.1416 -1.96415 -22.5281 8.75093 -6.81493 -1.3361C20.5156 -18.8814 25.498 12.4538 48.8806 15.366C59.0086 16.6271 60.749 10.3282 69.5491 15.366C78.3491 20.4037 94.3881 22.0372 106.404 20.5696",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-46.7832 15.8651C-26.1414 -3.36348 -23.55 5.54579 -6.81474 -2.73543C26.4751 -19.2089 25.7848 10.1582 49.1678 13.0704C59.2959 14.3316 61.4192 9.65921 70.2188 14.697C79.0188 19.7347 94.3883 20.6379 106.404 19.1703",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-46.7832 11.8744C-26.1414 -7.35458 -23.3726 1.90396 -6.81475 -6.72653C27.3515 -24.5349 24.9798 7.62506 48.402 10.199C57.1094 11.1561 61.7896 6.31551 71.7495 12.0173C81.7093 17.719 94.3878 16.6472 106.403 15.1796",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-46.7832 8.75801C-26.1414 -10.471 -24.2799 -3.23805 -6.81475 -9.84294C31.2746 -24.2475 24.9798 4.50866 48.402 7.0826C57.1094 8.03965 61.7896 3.19911 71.7495 8.90085C81.7093 14.6026 94.3878 13.5308 106.403 12.0632",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-46.7832 6.14473C-26.1414 -13.0843 -24.2799 -5.85087 -6.81475 -12.4562C31.2746 -26.8608 24.9798 1.89537 48.402 4.46932C57.1094 5.42637 61.7896 0.585826 71.7495 6.28757C81.7093 11.9893 94.3878 10.9175 106.403 9.44993",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-46.7832 3.48652C-26.1414 -15.7425 -24.2799 -8.50908 -6.81475 -15.1144C31.2746 -29.519 24.9798 -0.762832 48.402 1.81111C57.1094 2.76816 61.7896 -2.07284 71.7495 3.62937C81.7093 9.33111 94.3878 8.25933 106.403 6.79173",
    stroke: "white",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-45.8975 0.606638C-25.2557 -18.6224 -23.3941 -11.389 -5.92902 -17.9943C32.1603 -32.3989 25.8656 -3.64271 49.2882 -1.06877C57.9956 -0.111724 62.6753 -4.95226 72.6356 0.749483C82.596 6.45123 95.2744 5.37945 107.29 3.91185",
    stroke: "white",
    strokeWidth: 0.3
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 11.75V17.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21.75,
    r: 1,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2063_44293",
    x: 0.44342,
    y: 0.531128,
    width: 41.1132,
    height: 38.9689,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2063_44293"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2063_44293",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestIcon);
export default __webpack_public_path__ + "static/media/request-icon.a3064bab2516a465dd55d299e6094725.svg";
export { ForwardRef as ReactComponent };